// extracted by mini-css-extract-plugin
module.exports = {"detailList":"PrepaidItemSectionItemApplicable-Jtails_detailList_3nvyc","isStyleDingBeauty":"PrepaidItemSectionItemApplicable-Jtails_isStyleDingBeauty_3A9hw"};